export default function CtaSection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20flat%20lay%20of%20fashion%20essentials%20sneakers%20watch%20sunglasses%20notebook%20and%20coffee%20on%20warm%20wooden%20table%2C%20morning%20sunlight%20streaming%20from%20large%20window%2C%20lifestyle%20photography%2C%20cozy%20productive%20morning%20vibe%2C%20warm%20golden%20tones%2C%20aerial%20view&width=1800&height=800&seq=cta-v2-hoobuy-wide&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos selecionados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none mb-6">
              hoobuyspreadsheet
            </h2>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-accent-400 transition-all duration-200"
            >
              <span>Acessar Agora</span>
              <span className="w-7 h-7 rounded-full bg-foreground-900 flex items-center justify-center">
                <i className="ri-arrow-right-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
            </a>
          </div>

          <div className="lg:max-w-md">
            <p className="text-background-200 text-sm md:text-base leading-relaxed">
              Economize até <strong className="text-accent-400">40% nas suas compras</strong> internacionais com o Hoobuy Spreadsheet. Links verificados, atualização diária e segurança anti-scam. A ferramenta mais completa para compradores inteligentes em 2026.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}